
import React from 'react';

const GameDescription = () => {
  return (
    <section className="my-16">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold mb-8 text-center text-purple-300">About Time Shooter 3 Unblocked</h2>
        
        <div className="bg-indigo-900/50 p-6 rounded-xl shadow-xl mb-10">
          <div className="flex flex-col md:flex-row gap-8 items-center">
            <div className="md:w-1/2">
              {/* SVG Game Logo */}
              <svg viewBox="0 0 300 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
                <rect x="10" y="10" width="280" height="180" rx="15" fill="#1A1F2C" stroke="#7E69AB" strokeWidth="3"/>
                <path d="M60 50 L240 50" stroke="#6E59A5" strokeWidth="4" strokeLinecap="round"/>
                <path d="M150 20 L150 180" stroke="#9b87f5" strokeWidth="4" strokeOpacity="0.6" strokeDasharray="10 5"/>
                <text x="150" y="100" fontSize="24" fill="#D6BCFA" fontWeight="bold" textAnchor="middle">TIME SHOOTER 3</text>
                <text x="150" y="130" fontSize="18" fill="#8B5CF6" textAnchor="middle">SWAT EDITION</text>
                <circle cx="60" cy="100" r="25" fill="#33C3F0" fillOpacity="0.5"/>
                <circle cx="240" cy="100" r="25" fill="#1EAEDB" fillOpacity="0.5"/>
              </svg>
            </div>
            <div className="md:w-1/2">
              <p className="text-lg mb-4 text-indigo-100">
                <span className="text-purple-300 font-semibold">Time Shooter 3 Unblocked</span> is an intense first-person shooter game where you take on the role of an elite SWAT operative. This free online FPS game brings heart-pounding action right to your browser without requiring any downloads.
              </p>
              <p className="text-lg text-indigo-100">
                With its unique time-manipulation mechanics, you can slow down time to perform precise shots and tactical maneuvers. Navigate through challenging missions, eliminate hostile targets, and complete objectives in this action-packed shooter experience.
              </p>
            </div>
          </div>
        </div>
        
        <div className="space-y-6 text-lg">
          <p>
            <span className="text-purple-300 font-semibold">Time Shooter 3 Unblocked</span> takes the popular Time Shooter series to new heights with enhanced graphics, more varied missions, and an expanded arsenal of weapons. As a member of an elite SWAT unit, you'll be sent into high-stakes situations requiring quick reflexes, tactical thinking, and precision shooting.
          </p>
          
          <p>
            What sets <span className="text-purple-300 font-semibold">Time Shooter 3</span> apart from other free online shooter games is its innovative time-slowing mechanic. When activated, this ability allows you to carefully plan your shots, avoid enemy fire, and execute complex maneuvers that would be impossible in real-time. This mechanic adds a strategic layer to the fast-paced action, making each encounter a puzzle to solve rather than just a test of reflexes.
          </p>
          
          <p>
            The game features multiple environments, from urban settings to industrial complexes, each carefully designed to provide tactical challenges and opportunities. Whether you're clearing rooms, rescuing hostages, or defusing bombs, each mission will test different aspects of your skills as an elite operative.
          </p>
          
          <p>
            <span className="text-purple-300 font-semibold">Time Shooter 3 Unblocked</span> is optimized to run smoothly in your browser, making it accessible wherever you are. The controls are intuitive and customizable, allowing both new players and FPS veterans to jump in and enjoy the action immediately. With its combination of strategic depth and moment-to-moment intensity, Time Shooter 3 offers a premium gaming experience completely free online.
          </p>
        </div>
      </div>
    </section>
  );
};

export default GameDescription;
